import { ReactNode } from 'react';
import { Typography } from 'antd';
import styles from './index.module.scss';

type TextErrorProps = {
  /* `ReactNode` rather than `string` so a message can carry an inline link — the
     already-taken email offers a "sign in" anchor. Rendered as children either way. */
  msg: ReactNode;
  qaSelector?: string;
  [key: string]: any;
};

function TextError({ msg, qaSelector, ...rest }: TextErrorProps) {
  return (
    <Typography.Text
      className={styles.container}
      {...rest}
      data-qa-selector={qaSelector}
    >
      {msg}
    </Typography.Text>
  );
}

export default TextError;
